import React from 'react';
import Header from './components/Header';
import Container from './Container';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Container />
    </div>
  );
}

export default App;
